Controller.$inject = [];

function Controller() {

}

export function HuiMenuHeader() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `<div class="hui-menu-header" ng-transclude></div>`;
        }
    }
}